import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgoService } from 'src/app/shared/services/ngo/ngo.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';
import { ProjectService } from 'src/app/shared/services/project/project.service';
// import menu from './menu.json';
import { environment } from 'src/environments/environment';
import { filter, Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
  selector: 'app-logged-in-menu',
  templateUrl: './logged-in-menu.component.html',
  styleUrl: './logged-in-menu.component.scss',
})
export class LoggedInMenuComponent implements OnInit, AfterViewInit {
  public sessionUser: any;
  public adminTitle: string = null;
  public isNgoAdmin: boolean = false;
  public isShohayAdmin: boolean = false;
  public isCorporate: boolean = false;
  public isOpsAdmin: boolean = false;

  public isOpen = false;
  public userNgoList: any = [];
  public projectList: any = [];
  public selectedNgo: any = null;

  public menu: any[];
  public menuItems: any[];
  public activeIndex: string;
  public activeMenuId: string;
  public activeSubmenuIndex: string;
  public menuOpen: boolean = true;
  public open = new Map<string, boolean>();
  private subscription!: Subscription;
  public menuList;

  constructor(
    private readonly router: Router,
    private readonly ngoService: NgoService,
    private readonly authService: AuthService,
    public readonly projectService: ProjectService,
    public readonly localStorageService: LocalStorageService,
    private readonly commonSharedService: CommonSharedServiceService
  ) {
    this.sessionUser = this.localStorageService.getSessionUser();
    if (!this.localStorageService.getMenu()) {
      const roleId =
        this.localStorageService.getSelectedRole()?.short_form === 'donor'
          ? 'd40e4c6d-a877-4618-b0bf-4438a44364cb'
          : this.localStorageService.getSelectedRole()?.role_id;
      this.authService.getMenuByRole(roleId).subscribe({
        next: (response) => {
          this.menuList = response.sort(
            (a, b) => Number(a.order) - Number(b.order)
          );
          this.localStorageService.setMenu(this.menuList);
          this.localStorageService.setSelectedMenuInfo(this.menuList[0]);
        },

        error: (err) => {
          console.error('Failed to load menu', err);
        },
      });
    }

    this.isShohayAdmin = this.localStorageService.getIsSuperAdmin();
    this.menu = this.localStorageService
      .getMenu()
      ?.sort((a, b) => Number(a.order) - Number(b.order));

    this.isNgoAdmin = this.localStorageService.getIsNgoAdmin();

    this.isCorporate =
      this.localStorageService.getIsCorporateAdmin() ||
      this.localStorageService.getIsCorporateEmployee() ||
      this.localStorageService.getIsCampaignManager() ||
      this.localStorageService.getIsCustomEmployee();

    this.isOpsAdmin = this.localStorageService.getIsShohayOpsAdmin();
    this.localStorageService.menu$.subscribe((menu) => {
      if (menu.length) {
        this.menuItems = this.filterMenu(
          menu,
          this.localStorageService.getIsCustomEmployee()
            ? this.localStorageService.getSelectedRole()?.role_name
            : this.isNgoAdmin
            ? 'admin'
            : this.isOpsAdmin
            ? 'shohay_ops'
            : this.localStorageService.getSelectedRole()?.short_form,
          environment.production
        );
      }
    });

    // this.menuItems = this.filterMenu(
    //   this.menu,
    //   this.isNgoAdmin
    //     ? 'admin'
    //     : this.isOpsAdmin
    //     ? 'ops-admin'
    //     : this.sessionUser?.role?.short_form,
    //   environment?.production
    // );

    if (this.isNgoAdmin) {
      this.getNgoByUserId();
    } else if (this.isShohayAdmin || this.isOpsAdmin) {
      this.getAllVerifiedNgos();
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setActiveMenuByUrl(event.urlAfterRedirects);
      });
  }
  public async getMenu(roleId: string) {
    this.authService.getMenuByRole(roleId).subscribe({
      next: (response) => {
        this.localStorageService.setMenu(response);
      },
    });
  }

  private filterMenu(menu: any[], origin: string, prod: boolean): any[] {
    prod = environment?.production || environment?.envName === 'stage';

    const filterMenu = menu.reduce((acc, parent) => {
      if (parent.origin === origin && (!prod || parent.is_prod)) {
        const filteredSubmenu = parent.submenu.filter(
          (child) => child.origin === origin && (!prod || child.is_prod)
        );

        if (filteredSubmenu.length > 0) {
          this.open.set(parent.menu_key, false);
        }
        acc.push({ ...parent, submenu: filteredSubmenu });
      }
      return acc;
    }, []);

    if (this.localStorageService.getSelectedRole()?.short_form === 'admin') {
      filterMenu.pop();
    }

    return filterMenu;
  }

  public ngOnInit(value: any = null) {
    // this.getMenu(this.sessionUser?.role?.role_id);
    this.getAdminTitle();

    const selectedMenu = this.localStorageService.getSelectedMenuInfo();
    this.activeIndex = selectedMenu.menu_key;
    this.activeMenuId = selectedMenu?.menu_id;
    this.activeSubmenuIndex =
      this.localStorageService.getSelectedSubMenuInfo()?.menu_key;

    this.selectedNgo = this.localStorageService.getNgoInLocalStorage();

    this.commonSharedService.ngoProfile$.subscribe(() => {
      this.getNgoByUserId();
    });

    this.commonSharedService.subMenuSelected$.subscribe((subMenu) => {
      this.setSubMenuIndex(subMenu);
    });

    this.commonSharedService.companyLogoUpdated$.subscribe(() => {
      this.sessionUser = this.localStorageService.getSessionUser();
    });
  }

  private setActiveMenuByUrl(currentUrl: string): void {
    this.activeIndex = '';
    this.activeSubmenuIndex = '';

    currentUrl = currentUrl.split('?')[0].replace(/\/$/, '');
    for (const item of this.menuItems) {
      if (item.submenu.length === 0 && item.router_link === currentUrl) {
        this.setMenuIndex(item);
      }
      if (item.submenu.length > 0) {
        for (const subItem of item.submenu) {
          if (subItem.router_link === currentUrl) {
            this.setMenuIndex(item);
            this.setSubMenuIndex(subItem);
          }
        }
      }
    }
  }

  private getAdminTitle(): void {
    const role = this.localStorageService.getSelectedRole().short_form;
    if (
      this.localStorageService
        .getSelectedRole()
        ?.short_form.toLowerCase()
        .startsWith('custom')
    ) {
      this.adminTitle = this.localStorageService.getSelectedRole().role_name;
      return;
    }

    switch (role) {
      case 'system_admin':
        this.adminTitle = 'Admin Console';
        break;
      case 'corporate_admin':
        this.adminTitle = 'Corporate Admin';
        break;
      case 'campaign_manager':
        this.adminTitle = 'Campaign Manager';
        break;
      case 'store_manager':
        this.adminTitle = 'Store Manager';
        break;
      case 'corporate_employee':
        this.adminTitle = 'Corporate';
        break;
      case 'shohay_ops':
        this.adminTitle = 'Ops Admin';
        break;
      case '':
        this.adminTitle = 'Ops Admin';
        break;
      default:
        this.adminTitle = null;
        break;
    }
  }

  public ngAfterViewInit(): void {
    if (this.open.has(this.activeIndex)) {
      this.open.set(this.activeIndex, true);
      this.handleNavBarOpen(this.activeMenuId);
    }
  }

  private getAllVerifiedNgos(): void {
    this.ngoService.getAllVerifiedNgos().subscribe({
      next: (result) => {
        this.userNgoList = result;
      },
    });
  }

  private getNgoByUserId(): void {
    this.ngoService
      .getNgoByUserId(this.sessionUser?.id)
      .subscribe((result: any) => {
        this.userNgoList = result.filter(
          (user) => user.approval_status === 'ACCEPTED'
        );

        if (this.userNgoList?.length === 0) {
          for (const item of this.menuItems) {
            if (item.name === 'Manage') {
              item.router_link = '/dashboard/manage/my-organization';
              item.submenu = [];
              this.open.delete(item.menu_key);
              break;
            }
          }
        }

        if (this.selectedNgo) {
          const index = result.findIndex(
            (item) => item.id === this.selectedNgo.id
          );
          this.selectedNgo = result[index];

          this.localStorageService.setNgoInLocalStorage(this.selectedNgo);
        }
      });
  }

  public selectNgo(ngo: any): void {
    this.isOpen = false;
    if (!(JSON.stringify(this.selectedNgo) === JSON.stringify(ngo))) {
      this.selectedNgo = ngo;
      this.localStorageService.setNgoInLocalStorage(ngo);
      this.localStorageService.deleteProjectFromLocalStorage();
      this.triggerNgoSelection();
    }
  }

  public setMenuIndex(menu: any): void {
    const menuItem = menu;

    this.activeIndex = menu.menu_key;
    this.localStorageService.setSelectedMenuInfo(menuItem);

    if (menu?.submenu?.length === 0) {
      this.activeSubmenuIndex = null;
      this.localStorageService.setSelectedSubMenuInfo(null);
    }
  }

  public setSubMenuIndex(subMenu: any): void {
    this.activeSubmenuIndex = subMenu.menu_key;
    this.localStorageService.setSelectedSubMenuInfo(subMenu);
  }

  public isActive(index: string): boolean {
    return this.activeIndex === index;
  }

  public toggleMenu(index: string): void {
    if (this.open.has(index)) {
      this.toggleOpen(index);
    }
  }

  private toggleOpen(index: string): void {
    const value = this.open.get(index);
    this.open.set(index, !value);
  }

  private handleNavBarOpen(className: string): void {
    var myCollapse = document.getElementById(className);
    myCollapse.classList.add('show');
  }

  private triggerNgoSelection() {
    this.commonSharedService.ngoSelected();
  }

  public routeToNgoProfilePage(ngo_id: string): void {
    const encryptedParams = this.localStorageService.encryptObjectUrl({
      id: ngo_id,
    });
    this.router.navigate(['/dashboard/manage/update-ngo-profile'], {
      queryParams: { data: encryptedParams },
    });
  }
}
